import { MutableRefObject, useEffect } from "react";

type RefType = MutableRefObject<any> | MutableRefObject<any>[];

export const useOutsideClick = (
  refs: RefType,
  callback: () => void,
  clickListenerOptions?: boolean | AddEventListenerOptions
) => {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const refArray = Array.isArray(refs) ? refs : [refs];
      const validRefArray = refArray.filter((ref) => ref?.current);
      const isOutside = validRefArray.every(
        (ref) => ref.current && !ref.current.contains(e.target)
      );
      if (isOutside) {
        callback();
      }
    };

    document.addEventListener("click", handleClick, clickListenerOptions);

    return () => {
      document.removeEventListener("click", handleClick, clickListenerOptions);
    };
  });
};
